import { render, staticRenderFns } from "./PrintDetails.vue?vue&type=template&id=766fd908&"
import script from "./PrintDetails.vue?vue&type=script&lang=js&"
export * from "./PrintDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports